<div class="container-fluid refund-dashboard-page dashboard-page">
    <div class="page-controls">
        <div class="period-block">
            <div class="section-label">Period</div>
            <p-selectButton [options]="periodOptions"
                            [ngModel]="selectedPeriod$ | async"
                            (onChange)="onPeriodChange($event.value)"
                            [allowEmpty]="false"
                            optionLabel="label"
                            optionValue="value"
                            class="period-select"></p-selectButton>
        </div>
    </div>

    <div class="stats-row">
        @let stats = (stats$ | async);
        @let statsUnavailable = !stats;

        <app-stat-tile label="Cancelled & Failed"
                       [value]="(cancelledFailedTotal$ | async) ?? 0"
                       [description]="(cancelledFailedDescription$ | async) ?? ''"
                       [unavailable]="statsUnavailable"></app-stat-tile>

        <app-stat-tile label="Refunds Issued"
                       [value]="(stats?.successfulRefundTotalAmount ?? 0) | toMajor | currency:'R '"
                       [description]="(issuedDescription$ | async) ?? ''"
                       [unavailable]="statsUnavailable"></app-stat-tile>

        <app-stat-tile label="Refund Rate"
                       [value]="(((refundRatePercent$ | async) ?? 0) | number:'1.0-1') + '%'"
                       [description]="(refundRateDescription$ | async) ?? ''"
                       [unavailable]="statsUnavailable"></app-stat-tile>
    </div>

    <div class="recent-refunds card">
        <div class="card-body">
            <div class="recent-refunds-header">
                <h5 class="section-title">Recent Refunds</h5>
            </div>

            <app-refund-table [refunds]="recentRefunds$ | async"
                              [loading]="(recentLoading$ | async) ?? false"
                              [error]="(recentError$ | async) ?? false"
                              [clientSideSort]="true"
                              [sortField]="defaultSortField"
                              [sortOrder]="defaultSortOrder"
                              [showActions]="true"
                              [menuItemsForRefund]="buildMenuItemsForRefund"
                              [clickable]="false"
                              emptyText="No recent refunds."></app-refund-table>

            <div class="recent-refunds-footer">
                <a class="navy-btn view-all-btn" [routerLink]="refundTransactionsPath">View All Refunds</a>
            </div>
        </div>
    </div>
</div>
